import React, { useEffect, useRef, useState } from "react";
import useForm from "../Hooks/useForm";
import '../StyleSheets/RequestStepTwo.css'
import imgLoader from '../Images/MeddipayLoaderEllipsis.gif'
import { Button, Modal } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useCreditRequest } from "../Context/useCreditRequest";
import TarsServices from "../Services/TarsServices";
import IntlTelInput from 'react-intl-tel-input-18';
import 'react-intl-tel-input-18/dist/main.css';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { useCreditRequestAuth } from "../Context/useCreditRequestAuth";
import CustomSelect from "./CustomSelect";
import { createRef } from "react";
import Privacy from "./Privacy";
import PersonalData from "./PersonalData";

// const age = (birthdate) => {
//     const today = new Date();
//     const age = today.getFullYear() - birthdate.getFullYear() -
//         (today.getMonth() < birthdate.getMonth() ||
//             (today.getMonth() === birthdate.getMonth() && today.getDate() < birthdate.getDate()));
//     return age;
// }

const esBisiesto = (year) => {
    return (year % 400 === 0) ? true :
        (year % 100 === 0) ? false :
            year % 4 === 0;
};


const RequestStepTwo = () => {


    const { setLogoSize, getEC, getCT } = useCreditRequest();
    const { getStorage, setStorage } = useCreditRequestAuth();

    let request = getStorage("request")

    const navigate = useNavigate();
    const initialForm = {
        firstName: request.cusFirstName ? request.cusFirstName : "", secondName: request.cusSecondName ? request.cusSecondName : "",
        firstSurname: request.cusFirstSurname ? request.cusFirstSurname : "", secondSurname: request.cusSecondSurname ? request.cusSecondSurname : "",
        year: request.year ? request.year : "", month: request.month ? request.month : "", day: request.day ? request.day : "",
        country: request.cusBirthCountry ? request.cusBirthCountry : (request.cusDocumentType === "CCC" ? "CO" : ""),
        nationality: request.cusNationality ? (request.cusDocumentType === "CCC" ? "CO" : request.cusNationality) : (request.cusDocumentType === "CCC" ? "CO" : ""), phoneCode: [{ value: "CO", name: "57" }], phone: request.cusPhone ? request.cusPhone : "", email: request.cusEmail ? request.cusEmail : "", gender: request.cusGender ? request.cusGender : null, dataPrivacyCheck: false, dataTreatmentCheck: false
    };
    const [sending, setSending] = useState(false);

    const firstNameRef = useRef(null);
    const firstSurnameRef = useRef(null);
    const secondSurnameRef = useRef(null);
    const phoneRef = useRef(null);
    const emailRef = useRef(null);
    const dayRef = useRef(null);
    const monthRef = useRef(null);
    const yearRef = useRef(null);



    const countryRef = createRef(null);

    const validateForm = (form) => {


        let errors = {};
        let regexEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

        if (!form.year.trim()) { errors.year = "El campo Año es requerido"; yearRef.current.focus(); }
        if (!form.month.trim()) { errors.month = "El campo Mes es requerido"; monthRef.current.focus(); }
        if (!form.day.trim()) { errors.day = "El campo Día es requerido"; dayRef.current.focus(); }

        if (form.day && form.month && form.year) {

            if (esBisiesto(form.year) && ('00' + form.month).slice(-2) === "02" && form.day > "29") { errors.day = "El campo Día es requerido" }

            if (!esBisiesto(form.year) && ('00' + form.month).slice(-2) === "02" && form.day > "28") { errors.day = "El campo Día es requerido" }


            if (["04", "06", "09", "11"].includes(('00' + form.month).slice(-2))) {
                if (form.day === "31") { errors.day = "El campo Día es requerido" }
            }

        }


        if (!form.dataTreatmentCheck) { errors.dataTreatmentCheck = "El campo dataTreatmentCheck es requerido" }
        if (!form.dataPrivacyCheck) { errors.dataPrivacyCheck = "El campo dataPrivacyCheck es requerido" }
        if (!form.gender) { errors.gender = "El campo Genero es requerido" }


        if (!form.email.trim() || !regexEmail.test(form.email.trim())) { errors.email = "El campo Correo electronico es requerido"; emailRef.current.focus(); }

        if (!form.phone.trim()) { errors.phone = "El campo Telefono es requerido"; phoneRef.current.tel.focus() }
        if (form.phone.trim() && form.phone.length !== 10) { errors.phone = "El campo Telefono es erroneo"; phoneRef.current.tel.focus() }

        if (form.phoneCode.length === 0) { errors.phoneCode = "El campo Indicativo es requerido" }

        if (!form.nationality.trim()) { errors.nationality = "El campo Nacionalidad es requerido" }

        if (!form.country.trim()) { errors.country = "El campo Pais de nacimiento es requerido"; countryRef.current.focus(); }
        // if (request.cusDocumentType === "CCC" && (!form.secondSurname.trim() || form.secondSurname.length <= 1)) { errors.secondSurname = "El campo Segundo apellido es requerido"; secondSurnameRef.current.focus() }
        if (!form.firstSurname.trim() || form.firstSurname.length <= 1) { errors.firstSurname = "El campo Primer apellido es requerido"; firstSurnameRef.current.focus(); }
        if (!form.firstName.trim() || form.firstName.length <= 1) { errors.firstName = "El campo Primer nombre es requerido"; firstNameRef.current.focus(); }








        return errors;

    };

    const { form, errors, handleChange, handleChecked, handleSubmit, handleChangeDate, handleChangeTypeahead, handleChangeSelect } = useForm(initialForm, validateForm);
    const [countries, setCountries] = useState([]);
    const [phoneCodes, setPhoneCodes] = useState([]);
    // const countryRef = React.useRef();
    // const nationalityRef = React.useRef();
    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);
    const [show2, setShow2] = useState(false);

    const [genders, setGenders] = useState([]);
    const { newCustomer } = TarsServices();
    const handleClose = () => setShow(false);
    const handleClose1 = () => setShow1(false);
    const handleClose2 = () => setShow2(false);
    const handleShow = () => setShow(true);
    const handleShow1 = () => setShow1(true);
    const handleShow2 = () => setShow2(true);
    const MySwal = withReactContent(Swal);

    useEffect(() => {
        setLogoSize({ width: "240px", marginTop: "40px", marginBottom: "30px" })
        setSending(true);

        navigator.mediaDevices.enumerateDevices().then(result => {
            let camera = result.find(c => c.kind === "videoinput");

            if (camera) {
                MySwal.fire({
                    title: "Mas adelante te pediremos acceso a la cámara",

                    html: <>
                        <br></br>
                        <svg width="90" height="90" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ababab"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M18.3944 7C18.9574 7 19.2389 7 19.4711 7.05628C20.199 7.2327 20.7673 7.801 20.9437 8.52887C21 8.76107 21 9.04256 21 9.60555L21 16C21 17.8856 21 18.8284 20.4142 19.4142C19.8284 20 18.8856 20 17 20L16 20L8 20L7 20C5.11438 20 4.17157 20 3.58579 19.4142C3 18.8284 3 17.8856 3 16L3 9.60555C3 9.04256 3 8.76107 3.05628 8.52887C3.23271 7.801 3.80101 7.2327 4.52887 7.05628C4.76107 7 5.04257 7 5.60555 7V7C5.92098 7 6.07869 7 6.2261 6.9779C6.68235 6.90952 7.10092 6.6855 7.4109 6.34382C7.51105 6.23342 7.59853 6.1022 7.7735 5.83975L8 5.5C8.39637 4.90544 8.59456 4.60816 8.86549 4.40367C9.03094 4.27879 9.2148 4.18039 9.41048 4.112C9.73092 4 10.0882 4 10.8028 4L13.1972 4C13.9118 4 14.2691 4 14.5895 4.112C14.7852 4.18039 14.9691 4.27879 15.1345 4.40367C15.4054 4.60816 15.6036 4.90544 16 5.5L16.2265 5.83975C16.4015 6.1022 16.4889 6.23342 16.5891 6.34382C16.8991 6.6855 17.3177 6.90952 17.7739 6.9779C17.9213 7 18.079 7 18.3944 7V7Z" stroke="#858585" strokeWidth="2" strokeLinejoin="round"></path> <path d="M15 13C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13C9 11.3431 10.3431 10 12 10C13.6569 10 15 11.3431 15 13Z" stroke="#858585" strokeWidth="2"></path> </g></svg>
                        <br></br><br></br> <br></br><b>En el paso 4 te pediremos tomar foto de la cédula y una foto tipo selfie, por favor, asegurate de tener a mano la cédula antes de continuar. </b>
                        <br></br>
                        <br></br>

                    </>,
                    showCancelButton: false,
                    confirmButtonColor: "#00A9EB",
                    showConfirmButton: true,
                    showCloseButton: true,
                    showDenyButton: false,
                    allowEnterKey: false,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                })
            }
            else {
                MySwal.fire({
                    title: "Realiza el proceso en un dispositivo con cámara",

                    html: <>
                        <br></br>
                        <svg width="90" height="90" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15 18.9372C14.0645 18.9771 13.0495 19 12 19C8 19 4.5 18.6667 4 18.3333C3.5 18 3 15.6667 3 13C3 10.7849 3.34499 8.79986 3.7484 8M12 16C10.3431 16 9 14.6569 9 13M3 3L21 21M10 5.16181C10.4888 5.06081 11.1374 5 12 5C17 5 14.8083 7.04298 16 7.11352C18.1268 7.2394 19.6796 7.45303 20 7.66667C20.5 8 21 10.3333 21 13C21 14.0946 20.9158 15.133 20.7819 16" stroke="#858585" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
                        <br></br><br></br> <br></br><b>Recuerda que se te pedirá validar tu identidad más adelante en el proceso mediante fotos de tu rostro y de tu documento de identidad, asegúrate de realizar el proceso en un dispositivo con cámara </b>
                        <br></br>
                        <br></br>

                    </>,
                    showCancelButton: false,
                    showConfirmButton: false,
                    showCloseButton: false,
                    showDenyButton: false,
                    allowEnterKey: false,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                })
            }
        }

        )

        // navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
        //     stream.getTracks().forEach(function (track) {
        //         track.stop();
        //     });

        // }).catch((err) => {
        //     MySwal.fire({
        //         title: "SE NECESITAN PERMISOS PARA ACCEDER A LA CAMARA",

        //         html: <>
        //         <br></br><svg width="90" height="84" viewBox="0 0 90 84" fill="none" xmlns="http://www.w3.org/2000/svg" className="sc-dmfyKz evCKng"><path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M5.63623 32.771C5.63623 28.3527 9.21795 24.771 13.6362 24.771H26.0604C28.7057 24.771 31.18 23.4633 32.6702 21.2777L34.7544 18.2208C36.2446 16.0352 38.7189 14.7275 41.3643 14.7275H47.6362H53.9082C56.5535 14.7275 59.0278 16.0352 60.518 18.2208L62.6023 21.2777C64.0925 23.4633 66.5668 24.771 69.2121 24.771H81.6362C86.0545 24.771 89.6362 28.3527 89.6362 32.771V69.7275C89.6362 74.1458 86.0545 77.7275 81.6362 77.7275H13.6362C9.21795 77.7275 5.63623 74.1458 5.63623 69.7275V32.771ZM65.3754 50.0754C65.3754 60.0165 57.3165 68.0754 47.3754 68.0754C37.4342 68.0754 29.3754 60.0165 29.3754 50.0754C29.3754 40.1342 37.4342 32.0753 47.3754 32.0753C57.3165 32.0753 65.3754 40.1342 65.3754 50.0754ZM23.3319 36.4232C25.541 36.4232 27.3319 34.6323 27.3319 32.4232C27.3319 30.214 25.541 28.4232 23.3319 28.4232C21.1227 28.4232 19.3319 30.214 19.3319 32.4232C19.3319 34.6323 21.1227 36.4232 23.3319 36.4232Z" fill="#B3BBC6"></path><path d="M57.9239 16.1126C56.9723 13.1219 54.1947 11.0908 51.0563 11.0908H36.9437C33.8053 11.0908 31.0277 13.1219 30.0761 16.1126C29.1245 19.1033 26.3469 21.1343 23.2085 21.1343H9.30435C5.27027 21.1343 2 24.4046 2 28.4386V66.7865C2 68.1705 2.38492 69.4646 3.05355 70.5676M13.8696 74.0908H45.3696M67.5307 21.1343H78.6957C82.7297 21.1343 86 24.4046 86 28.4386V66.7865C86 70.8206 82.7297 74.0908 78.6957 74.0908H53.1304" stroke="#B3BBC6" strokeWidth="3" strokeLinecap="round"></path><path d="M25.8374 49.0633C25.7049 48.1826 25.6362 47.2809 25.6362 46.3633C25.6362 36.4222 33.6951 28.3633 43.6362 28.3633C44.6905 28.3633 45.7236 28.4539 46.7281 28.6278M29.5841 57.6133C32.8829 61.7284 37.9519 64.3633 43.6362 64.3633C53.5774 64.3633 61.6362 56.3044 61.6362 46.3633C61.6362 40.6789 59.0013 35.61 54.8862 32.3112" stroke="#B3BBC6" strokeWidth="3" strokeLinecap="round"></path><path d="M23.9546 30.5459C23.9546 31.9266 22.8353 33.0459 21.4546 33.0459C20.0739 33.0459 18.9546 31.9266 18.9546 30.5459C18.9546 29.1652 20.0739 28.0459 21.4546 28.0459C22.8353 28.0459 23.9546 29.1652 23.9546 30.5459Z" stroke="#B3BBC6" strokeWidth="3"></path><path d="M3.81836 82L83.8183 2" stroke="#B3BBC6" strokeWidth="3" strokeLinecap="round"></path></svg>
        //         <br></br><br></br> <br></br><b>Por favor permite el uso de la camara y refresca la pagina</b>
        //             <br></br>
        //             <br></br>

        //         </>,
        //         showCancelButton: false,
        //         showConfirmButton: false,
        //         showCloseButton: false,
        //         showDenyButton: false,
        //         allowEnterKey: false,
        //         allowEscapeKey: false,
        //         allowOutsideClick: false,
        //     })

        // });

        getCT().then(data => {

            setSending(false);
            setCountries(data.map(el => { return { value: el.value, name: el.OriginalName } }))
            setPhoneCodes(data.map(el => { return { value: el.value, name: el.Phonecode } }))
        });

        getEC().then(data => {
            setGenders(data.filter(el => el.EnumerationId === "cusEnumGender")[0].EnumerationValues.map(el => { return { value: el.value, name: el.label } }))

        })

    }, []);

    const changePhone = (status, value, countryData, number, id) => {
        value = value.replace(/[^\w\s]/gi, "").replace(/[a-z]/gi, '').replaceAll(" ", "")

        // let p1 = ""
        // let p2 = ""
        // let p3 = ""
        // let temp = ""

        // if (value.length <= 3) {
        //     temp = value
        // }

        // if (value.length === 4) {
        //     p1 = value.slice(0, 3);
        //     p2 = value.slice(3, 4);
        //     temp = `${p1} ${p2}`
        // }
        // if (value.length === 5) {
        //     p1 = value.slice(0, 3);
        //     p2 = value.slice(3, 5);
        //     temp = `${p1} ${p2}`
        // }
        // if (value.length === 6) {
        //     p1 = value.slice(0, 3);
        //     p2 = value.slice(3, 6);
        //     temp = `${p1} ${p2}`
        // }
        // if (value.length >= 7) {
        //     p1 = value.slice(0, 3);
        //     p2 = value.slice(3, 6);
        //     p3 = value.slice(6);
        //     temp = `${p1} ${p2} ${p3}`
        // }
        // if (value.length > 10) {
        //     return;
        // }



        handleChange({ target: { name: "phone", value: value } });
    }

    const changePhoneCode = (num, country) => {
        let phoneCode = phoneCodes.find(el => el.name === Number(country.dialCode))
        handleChangeTypeahead([phoneCode], "phoneCode")
    }

    const submitForm = (form, error) => {
        form.phone = form.phone.replaceAll(" ", "")

        if (!error) {

            setSending(true);

            let body =
            {
                cusType: request.cusType ?? "REG",
                cusDocumentType: request.cusDocumentType,
                cusDocument: request.cusDocument,
                cusFirstName: form.firstName?.replaceAll('\t',''),
                cusSecondName: form.secondName?.replaceAll('\t',''),
                cusFirstSurname: form.firstSurname?.replaceAll('\t',''),
                cusSecondSurname: form.secondSurname?.replaceAll('\t',''),
                cusGender: form.gender,
                cusBirthDate: form.year + "-" + ('00' + form.month).slice(-2) + "-" + ('00' + form.day).slice(-2),
                cusNationality: form.nationality,
                cusBirthCountry: form.country,
                cusEmail: form.email,
                cusPhoneCountry: form.phoneCode[0].value,
                cusPhone: form.phone,
                cusConditionsAcceptance: true
            }


            newCustomer(body).then(resCus => {

                if (resCus.status === 201) {

                    setSending(false);

                    let data = JSON.parse(resCus.data.data)

                    if (!data.ValidCommunication) {
                        setStorage("request", {
                            ...request,
                            cusPhone: form.phone,
                            cusPhoneCountry: form.phoneCode[0].value,
                            phoneCodeTemp: "+" + form.phoneCode[0].name,
                            cusEmail: form.email,
                            cusFirstName: form.firstName?.replaceAll('\t',''),
                            cusSecondName: form.secondName?.replaceAll('\t',''),
                            cusFirstSurname: form.firstSurname?.replaceAll('\t',''),
                            cusSecondSurname: form.secondSurname?.replaceAll('\t',''),
                            year: form.year,
                            month: form.month,
                            day: form.day,
                            cusNationality: form.nationality,
                            cusBirthCountry: form.country,


                            cusGender: form.gender,
                            state: 2
                        });

                        navigate("/DigitalConfirmation");
                    }

                    else {
                        setStorage("request", {
                            ...request,
                            cusPhone: form.phone,
                            cusPhoneCountry: form.phoneCode[0].value,
                            phoneCodeTemp: "+" + form.phoneCode[0].name,
                            cusEmail: form.email,
                            cusFirstName: form.firstName?.replaceAll('\t',''),
                            cusSecondName: form.secondName?.replaceAll('\t',''),
                            cusFirstSurname: form.firstSurname?.replaceAll('\t',''),
                            cusSecondSurname: form.secondSurname?.replaceAll('\t',''),
                            year: form.year,
                            month: form.month,
                            day: form.day,
                            cusNationality: form.nationality,
                            cusBirthCountry: form.country,


                            cusGender: form.gender,
                            state: 4
                        });

                        navigate("/Profile");
                    }




                }
                else {
                    setSending(false);
                    MySwal.fire({
                        html: resCus.data.message,
                        icon: 'error'
                    })
                }
            });





        }
        else {
            MySwal.fire({
                html: "Completa todos los campos",
                icon: 'warning'
            })
        }

    }

    return (
        <>
            <form onSubmit={(e) => handleSubmit(e, submitForm)}>
                <table id="step-two-table">
                    <tbody>

                        <tr>
                            <td style={{ textAlign: "center", color: "gray", fontSize: "13px" }} colSpan={2}>{request.cusDocumentTypeTemp}   {request.cusDocument}</td>

                        </tr>
                        <tr>
                            <td style={{ textAlign: "center", color: "gray", padding: "0px" }} colSpan={2}>
                                <h3><b style={{ color: "black" }}>1</b>/4</h3>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <div className="form-floating">
                                    <input disabled={request.disableName} ref={firstNameRef} type="text" name="firstName" value={form.firstName} onChange={handleChange} className={`form-control ${errors.firstName && "is-invalid"}`} placeholder="Primer nombre" autoComplete="off" />
                                    <label htmlFor="firstName">Primer nombre</label>
                                </div>

                            </td>
                            <td>
                                <div className="form-floating">
                                    <input disabled={request.disableName} type="text" name="secondName" value={form.secondName} onChange={handleChange} className={`form-control ${errors.secondName && "is-invalid"}`} placeholder="Segundo nombre" autoComplete="off" />
                                    <label htmlFor="secondName">Segundo nombre</label>
                                </div>

                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div className="form-floating">
                                    <input disabled={request.disableName} ref={firstSurnameRef} type="text" name="firstSurname" value={form.firstSurname} onChange={handleChange} className={`form-control ${errors.firstSurname && "is-invalid"}`} placeholder="Primer apellido" autoComplete="off" />
                                    <label htmlFor="firstSurname">Primer apellido</label>
                                </div>

                            </td>
                            <td>
                                <div className="form-floating">
                                    <input disabled={request.disableName} ref={secondSurnameRef} type="text" name="secondSurname" value={form.secondSurname} onChange={handleChange} className={`form-control ${errors.secondSurname && "is-invalid"}`} placeholder="Segundo apellido" autoComplete="off" />
                                    <label htmlFor="secondSurname">Segundo apellido</label>
                                </div>

                            </td>
                        </tr>
                        <tr>


                            <td colSpan={2} >





                                <CustomSelect ref={countryRef} name="country" value={form.country} options={countries} text="País de nacimiento" error={errors.country} handleChangeSelect={handleChangeSelect} />


                            </td>
                        </tr>

                        {request.cusDocumentType !== "CCC" && (<tr>
                            <td colSpan={2}>


                                <CustomSelect name="nationality" value={form.nationality} options={countries} text="Nacionalidad" error={errors.nationality} handleChangeSelect={handleChangeSelect} />

                            </td>
                        </tr>
                        )}





                        <tr>



                            <td colSpan={2}>

                                <IntlTelInput
                                    ref={phoneRef}
                                    containerClassName="intl-tel-input"
                                    inputClassName={`form-control ${errors.phone && "is-invalid"}`}
                                    placeholder="Teléfono"
                                    preferredCountries={[]}
                                    onPhoneNumberChange={changePhone}
                                    onSelectFlag={changePhoneCode}
                                    name="phone"
                                    defaultCountry="co"
                                    onlyCountries={["co"]}
                                    value={form.phone}
                                />



                            </td>

                        </tr>

                        <tr>
                            <td colSpan={2}>
                                <div className="form-floating" >
                                    <input ref={emailRef} type="email" name="email" value={form.email} onChange={handleChange} className={`form-control ${errors.email && "is-invalid"}`} placeholder="Correo electrónico" autoComplete="off" />
                                    <label htmlFor="email">Correo electrónico</label>
                                </div>

                            </td>
                        </tr>
                        <tr>


                            <td colSpan={2}>
                                <hr className="hr-text" data-content="Fecha de nacimiento"></hr>
                                <div style={{ display: "inline-flex", width: "100%" }}>

                                    <div className="form-floating" style={{ marginRight: "5px" }} >
                                        <input ref={dayRef} inputMode="numeric" type="number" name="day" value={form.day} onChange={handleChangeDate} placeholder="Dia" autoComplete="off" className={`form-control ${errors.day && "is-invalid"}`} min="1" max="31" />
                                        <label htmlFor="dia">Dia</label>
                                    </div>


                                    <div className="form-floating" >
                                        <input ref={monthRef} inputMode="numeric" type="number" name="month" value={form.month} onChange={handleChangeDate} placeholder="Mes" autoComplete="off" className={`form-control ${errors.month && "is-invalid"}`} min="1" max="12" />
                                        <label htmlFor="mes">Mes</label>
                                    </div>

                                    <div className="form-floating" style={{ marginLeft: "5px" }}>
                                        <input ref={yearRef} inputMode="numeric" type="number" name="year" value={form.year} onChange={handleChange} placeholder="Año" autoComplete="off" className={`form-control ${errors.year && "is-invalid"}`} min="1900" max={(new Date().getFullYear()) - 18} />
                                        <label htmlFor="anio">Año</label>
                                    </div>
                                </div>

                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <hr className="hr-text" data-content="Género"></hr>
                                <div className="container-fluid" id="divGeneros">
                                    <div className="row" style={{ textAlign: "center" }}>

                                        {
                                            genders.length > 0 && (
                                                genders.map(el => {
                                                    return (
                                                        <div className="col" key={el.value}>
                                                            <input type="radio" className="btn-check" name="gender" id={el.value} value={el.value} onChange={handleChange} autoComplete="off" required defaultChecked={el.value === request.cusGender} />
                                                            <label style={{ width: "100px" }} className="btn btn-outline-secondary" htmlFor={el.value}>{el.name}</label>
                                                        </div>
                                                    )
                                                })
                                            )
                                        }
                                    </div>

                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td colSpan={2} style={{ textAlign: "center" }}>

                                <div className="form-check" style={{ marginLeft: "10px" }}>
                                    <input className="form-check-input" type="checkbox" checked={form.dataPrivacyCheck} id="checkPrivacidad" name="dataPrivacyCheck" onChange={handleChecked} style={{ float: "initial", fontSize: "25px" }} />
                                    <label className="form-check-label" style={{ marginLeft: "10px", textAlign: "left" }}>
                                        Acepto la <u style={{ color: "blue", cursor: "pointer" }} onClick={handleShow1}>política de privacidad y tratamiento de datos personales</u>
                                        {/* Acepto la <a target="_blank" rel="noopener noreferrer" href="https://www.meddipay.com.co/privacy?section=policy">política de privacidad y tratamiento de datos personales</a> */}

                                    </label>
                                </div>


                            </td>
                        </tr>

                        <tr>
                            <td colSpan={2} style={{ textAlign: "center" }}>
                                <div className="form-check" style={{ marginLeft: "10px" }}>
                                    <input className="form-check-input" type="checkbox" checked={form.dataTreatmentCheck} id="checkTratamiento" name="dataTreatmentCheck" onChange={handleChecked} style={{ float: "initial", fontSize: "25px" }} />
                                    <label className="form-check-label" style={{ marginLeft: "10px", textAlign: "left" }}>
                                        Acepto el <u style={{ color: "blue", cursor: "pointer" }} onClick={handleShow}>Aviso de privacidad</u> y a ser contactado por los siguientes canales de cobranza:<br /> SMS, Correo electrónico, Llamada telefónica, Mensaje por aplicaciones
                                        {/* Acepto el <a target="_blank" rel="noopener noreferrer" href="https://www.meddipay.com.co/privacy?section=notice">Aviso de privacidad</a> y a ser contactado por los siguientes canales de cobranza:<br /> SMS, Correo electrónico, Llamada telefónica, Mensaje por aplicaciones */}
                                    </label>
                                </div>

                            </td>
                        </tr>

                        <tr>
                            <td style={{ textAlign: "center", color: "red" }} colSpan={2}>
                                {(errors.dataPrivacyCheck || errors.dataTreatmentCheck) && (<p>Debe aceptar las políticas</p>)}
                            </td>
                        </tr>


                        <tr>

                            <td style={{ textAlign: "center", padding: "10px" }} colSpan={2}>
                                <Link to="/" onClick={() => {
                                    setStorage("request", {
                                        ...request, state: 0
                                    })
                                }}>
                                    <button type="button" disabled={sending} className="btn btn-mp-back" style={{ marginRight: "20px" }}>Regresar</button>
                                </Link>

                                <input type="submit" value="Continuar" disabled={sending} className="btn btn-mp" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {sending &&
                                    (
                                        <div className="my-loader">
                                            <div className="my-loader-container">
                                                <img src={imgLoader} alt="loader"></img>

                                            </div>
                                        </div>
                                    )}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>


            <Modal show={show} onHide={handleClose} dialogClassName="modal-aut">
                <Modal.Header closeButton>

                </Modal.Header>

                <Modal.Body style={{ padding: "0" }}>

                    <div style={{ margin: "0 auto", width: "100%", textAlign: "justify", overflowY: "scroll", height: "500px", padding: "30px" }}>
                        <Privacy />
                    </div>

                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { handleChecked({ target: { name: "dataTreatmentCheck", checked: true } }); handleClose() }}>He leido y acepto</Button>
                    <Button variant="secondary" onClick={() => { handleChecked({ target: { name: "dataTreatmentCheck", checked: false } }); handleClose() }}>No acepto</Button>
                </Modal.Footer>
            </Modal>




            <Modal show={show1} onHide={handleClose1} dialogClassName="modal-aut" centered>
                <Modal.Header closeButton>

                </Modal.Header>

                <Modal.Body style={{ padding: "0" }}>
                    <div style={{ margin: "0 auto", width: "100%", textAlign: "justify", overflowY: "scroll", height: "500px", padding: "30px" }}>

                        <PersonalData />

                    </div>

                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { handleChecked({ target: { name: "dataPrivacyCheck", checked: true } }); handleClose1() }}>He leido y acepto</Button>
                    <Button variant="secondary" onClick={() => { handleChecked({ target: { name: "dataPrivacyCheck", checked: false } }); handleClose1() }}>No acepto</Button>
                </Modal.Footer>
            </Modal >


            {/* <Modal show={show2} onHide={handleClose2} dialogClassName="modal-aut">
                <Modal.Header closeButton>

                </Modal.Header>

                <Modal.Body>

                    <div style={{ margin: "0 auto", width: "100%", textAlign: "justify", overflowY: "scroll", height: "500px", padding: "30px" }}>

                        <p style={{ textAlign: "center" }}><b>AVISO DE PRIVACIDAD DE TRATAMIENTO DE DATOS PERSONALES</b>  </p>

                        <div className="container">


                            <div className="my-5">
                                <p></p>
                                <p>
                                    Meddipay S.A.S (En adelante Meddipay), identificada con NIT
                                    901763399-5, es responsable del tratamiento de los datos personales
                                    que son recolectados y almacenados en las bases datos. Su
                                    tratamiento se realiza conforme a su <a target="_blank" href="https://www.meddipay.com.co/privacy">Pol&iacute;tica de privacidad y
                                        tratamiento de datos personales</a>, respetando lo
                                    consagrado en la Ley 1581 de 2012 y dem&aacute;s normas
                                    concordantes.
                                </p>
                                <p></p>
                                <p className="text-mp-primary fs-3 fw-bold">Autorizaci&oacute;n</p>
                                <p></p>
                                <p>
                                    Esta es la autorizaci&oacute;n mediante la cual el usuario da su
                                    consentimiento previo, expreso e informado para que Meddipay
                                    almacene y procese sus datos personales, de acuerdo a la
                                    Pol&iacute;tica de privacidad y tratamiento de datos personales.
                                    
                                    Así mismo, el titular autoriza la transmisión y transferencia de sus datos a FIN TECHNOLOGIES SAS, con NIT 901.603.139-1, para el tratamiento de datos relacionado con consulta y reportes ante centrales de información financiera, en virtud al acuerdo de colaboración existente entre MEDDIPAY y FIN TECHNOLOGIES, para el perfilamiento y análisis de capacidad de endeudamiento de clientes de la plataforma MEDDIPAY, especialmente en lo relacionado con la finalidad #11 de clientes y usuarios.
                                </p>
                                <p></p>
                                <p className="text-mp-primary fs-3 fw-bold">Finalidades</p>
                                <p></p>
                                <p>
                                    Los datos ser&aacute;n almacenados y tratados por Meddipay, y sus
                                    terceros aliados, para las siguientes finalidades:
                                </p>
                                <p></p>
                                <p>
                                    1. Recolectar y almacenar la informaci&oacute;n en nuestras bases de
                                    datos.
                                </p>
                                <p>
                                    2. Dar cumplimiento a las obligaciones contra&iacute;das con
                                    nuestros usuarios y/o clientes.
                                </p>
                                <p>3. Prestar los servicios de forma correcta.</p>
                                <p>4. Ordenar y clasificar los datos personales suministrados.</p>
                                <p>
                                    5. Verificar los datos personales suministrados, para evitar fraudes
                                    o suplantaci&oacute;n de identidad.
                                </p>
                                <p>
                                    6. Creaci&oacute;n y gesti&oacute;n de los perfiles y/o cuentas de
                                    los usuarios y/o clientes.
                                </p>
                                <p>
                                    7. Mantener contacto y comunicaci&oacute;n con los titulares de los
                                    datos.
                                </p>
                                <p>
                                    8. Entablar comunicaci&oacute;n con los usuarios y/o clientes, a
                                    trav&eacute;s de llamadas, mensajes de texto, correo
                                    electr&oacute;nico o a trav&eacute;s de cualquier otro medio de
                                    comunicaci&oacute;n f&iacute;sico o digital.
                                </p>
                                <p>9. Para gesti&oacute;n administrativa, contable y fiscal.</p>
                                <p>
                                    10. Analizar el perfil crediticio y de riesgo de nuestros clientes
                                    y/o usuarios.
                                </p>
                                <p>
                                    11. Consultar a las centrales de informaci&oacute;n de riesgo,
                                    crediticia y comercial, el historial crediticio de los clientes y/o
                                    usuarios.
                                </p>
                                <p>
                                    12. Reportar a las centrales de riesgo incumplimiento de los
                                    usuarios y/o clientes de sus obligaciones financieras.
                                </p>
                                <p>
                                    13. Verificar el cumplimiento de las obligaciones de nuestros
                                    clientes y/o usuarios.
                                </p>
                                <p>
                                    14. Compartir con terceros, incluyendo la transferencia y
                                    transmisi&oacute;n (inclusive internacional), los datos personales
                                    de los usuarios y/o clientes.
                                </p>
                                <p>
                                    15. Recibir informaci&oacute;n de terceros sobre nuestros clientes
                                    y/o usuarios.
                                </p>
                                <p></p>
                                <p className="text-mp-primary fs-3 fw-bold">
                                    Datos personales almacenados y procesados
                                </p>
                                <p></p>
                                <p></p>
                                <p>
                                    Meddipay puede solicitar y almacenar datos necesarios para la
                                    correcta prestaci&oacute;n de sus servicios, tales como: 1) Datos de
                                    identificaci&oacute;n y de contacto, 2) informaci&oacute;n
                                    financiera (Ingresos, gastos, h&aacute;bitos), 3) informaci&oacute;n
                                    sobre profesi&oacute;n u oficio, 4) informaci&oacute;n
                                    demogr&aacute;fica, 5) datos sensibles.
                                </p>
                                <p></p>
                                <p className="text-mp-primary fs-3 fw-bold">Derechos del titular</p>
                                <p></p>
                                <p>Los titulares de los datos tienen los siguientes derechos:</p>
                                <p>
                                    1. Presentar solicitudes de actualizaci&oacute;n,
                                    informaci&oacute;n, eliminaci&oacute;n de sus datos personales.
                                </p>
                                <p>
                                    2. Ser informado del uso que hace Meddipay de sus datos personales.
                                </p>
                                <p>
                                    3. Presentar quejas ante las autoridades competentes por violaciones
                                    al r&eacute;gimen de protecci&oacute;n de datos.
                                </p>
                                <p>4. Revocar la autorizaci&oacute;n de tratamiento de datos.</p>
                                <p></p>
                                <p>
                                    Los clientes y/o usuarios solo podr&aacute;n revocar la
                                    autorizaci&oacute;n o suprimir los datos personales si no existe una
                                    obligaci&oacute;n legal o contractual que implique conservar los
                                    datos personales en las bases de datos de Meddipay.
                                </p>
                                <p></p>
                                <p></p>
                                <p className="text-mp-primary fs-3 fw-bold">
                                    Acceso a la informaci&oacute;n
                                </p>
                                <p></p>
                                <p>
                                    Puede tener acceso a los datos personales los titulares de la
                                    informaci&oacute;n (acreditando su identidad), los causahabientes
                                    (acreditando la calidad de causahabientes), los representantes o
                                    apoderados de los titulares de la informaci&oacute;n (acreditando la
                                    calidad de representante o apoderado)
                                </p>
                                <p></p>
                                <p>
                                    Los canales de atenci&oacute;n para acceso a la informaci&oacute;n
                                    son los siguientes:
                                </p>
                                <p></p>
                                <p>
                                    &middot; Atenci&oacute;n virtual <a data-fr-linked="true" href="mailto:hola@meddipay.com">hola@meddipay.com</a>
                                </p>
                                <p>
                                    &middot; Atenci&oacute;n presencial Carrera 28 C #71-28 Manizales
                                </p>
                            </div>
                        </div>

                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { handleChecked({ target: { name: "dataPrivacyCheck", checked: true } }); handleClose2() }}>He leido y acepto</Button>
                    <Button variant="secondary" onClick={() => { handleChecked({ target: { name: "dataPrivacyCheck", checked: false } }); handleClose2() }}>No acepto</Button>
                </Modal.Footer>
            </Modal> */}


        </>

    );
}

export default RequestStepTwo;